import {Checkbox, FormControlLabel} from "@mui/material";
import React, {ChangeEvent, FC, useEffect, useState} from "react";
import {IExportFeaturesProps} from "@ui/tableCustom/types/exportProps";
import {sx} from './sx'

interface IProps {
    id: string | number,
    exportFeaturesProps: IExportFeaturesProps,
    label?: string,
}

const ButtonToggleRowExport: FC<IProps> = ({
                                               id,
                                               exportFeaturesProps,
                                               label
                                           }) => {


    const {onChangeExportRow, hasExportRow, exportMode, exportDataFromAllPage} = exportFeaturesProps;
    const [checked, setChecked] = useState(() => hasExportRow ? hasExportRow(id?.toString()) : false)
    const handleChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setChecked(checked)
        if (onChangeExportRow) {
            onChangeExportRow(id?.toString())
        }
    }

    useEffect(() => {
        const checked = hasExportRow ? hasExportRow(id?.toString()) : false;
        setChecked(checked)
    }, [hasExportRow, exportFeaturesProps?.rerenderAllRowsDeps])

    if (!id || !exportMode) {
        return
    }

    if (label) {
        return (
            <FormControlLabel
                sx={sx.label}
                control={<Checkbox
                    sx={sx.checkbox}
                    onChange={handleChange}
                    disabled={exportDataFromAllPage}
                    checked={exportDataFromAllPage ? true : checked}
                />}
                label={label}
            />
        )
    }
    return (
        <Checkbox
            sx={sx.checkbox}
            onChange={handleChange}
            disabled={exportDataFromAllPage}
            checked={exportDataFromAllPage ? true : checked}
        />
    )
}

export default ButtonToggleRowExport;